import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/HelloWorld'
let ProdDetail = () => import(   /* webpackChunkName:"ProdDetail" */ /* webpackPrefetch:true */'../components/ProdDetail')

Vue.use(Router)


const router = new Router({

  mode: 'history',

  routes: [

    {
      path: '/',
      name: 'Home',
      component: Home
    },

    {
      path: '/productDetail',
      name: 'ProductDetail',
      component: ProdDetail
    }


  ]

})


export default router